import { WidgetConfig, WidgetData } from '../services/types';

interface WidgetProps {
  config: WidgetConfig;
  data: WidgetData;
  onDrillDown: (widgetId: string, filter?: string) => void;
}

// Map stat labels to filter values (same as MiniWidget)
const statLabelToFilter: Record<string, string> = {
  'New': 'new',
  'Wait Cust': 'waiting-customer',
  'Wait Us': 'waiting-us',
  'All': 'all',
};

export default function Widget({ config, data, onDrillDown }: WidgetProps) {
  const handleClick = () => {
    onDrillDown(config.id);
  };

  const handleStatClick = (e: React.MouseEvent, label: string) => {
    e.stopPropagation();
    const filterValue = statLabelToFilter[label];
    if (filterValue) {
      console.log(`Widget: Stat clicked - ${label} -> filter: ${filterValue}`);
      onDrillDown(config.id, filterValue);
    }
  };

  // Loading state
  if (data.status === 'loading') {
    return (
      <div className={`widget-card status-loading`}>
        <div className="widget-header">
          <h3>{config.icon} {config.name}</h3>
          <span className="status-dot status-loading" />
        </div>
        <div className="widget-loading">
          <div className="loading-spinner"></div>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  // Error state
  if (data.status === 'error') {
    return (
      <div
        className={`widget-card status-error`}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        <div className="widget-header">
          <h3>{config.icon} {config.name}</h3>
          <span className="status-dot status-error" />
        </div>
        <div className="widget-error">
          Unable to load data
          <br />
          <small>Click to open full dashboard</small>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`widget-card status-${data.status}`}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="widget-header">
        <h3>{config.icon} {config.name}</h3>
        <span className={`status-dot status-${data.status}`} />
      </div>

      {data.stats.length > 0 && (
        <div className="widget-stats">
          {data.stats.map((stat, index) => {
            // Add pulse class for critical stats with value > 0
            const isPulsing = stat.type === 'critical' && Number(stat.value) > 0;
            const isClickable = Boolean(statLabelToFilter[stat.label]);
            return (
              <button
                key={index}
                type="button"
                className={`stat ${stat.type || 'info'}${isPulsing ? ' pulse' : ''}${isClickable ? ' clickable' : ''}`}
                onClick={(e) => handleStatClick(e, stat.label)}
                title={isClickable ? `Click to filter by ${stat.label}` : undefined}
              >
                <span className="value">{stat.value}</span>
                <span className="label">{stat.label}</span>
              </button>
            );
          })}
        </div>
      )}

    </div>
  );
}
